import { render } from "./GeneralExport.vue?vue&type=template&id=77a3051d"
import script from "./GeneralExport.vue?vue&type=script&lang=js"
export * from "./GeneralExport.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__